import {ChangeDetectionStrategy, Component, Input} from '@angular/core'

@Component({
  selector: 'li[cft-holy-grail-grid-sidenav-list-item]',
  template: `
    <a class="inline-block w-full px-2xs py-xs" [routerLink]="[path]">
      {{ label }}
    </a>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference '../../../../styles/app-reference.css';

    :host {
      @apply list-item border-b border-grey-300 text-sm font-medium last:border-none hover:bg-grey-100 hover:text-president-400;
    }
  `,
})
export class HolyGrailGridSidenavListItemComponent {
  @Input() label!: string
  @Input() path!: string
}
